module.exports = __webpack_public_path__ + "img/icon_weixinkaifa.4249634f.png";